/* ============================================================
   ae-header.js  —  assets/ae-header.js
   American Eagle Style Header | Shopify Horizon Theme
   ============================================================ */
(function () {
  'use strict';

  /* ANNOUNCEMENT BAR */
  function initAnnCarousel(barId, trackId, prevId, nextId) {
    var bar=document.getElementById(barId),track=document.getElementById(trackId),prev=document.getElementById(prevId),next=document.getElementById(nextId);
    if(!bar||!track)return;
    var slides=Array.from(track.querySelectorAll('.ann-slide'));
    if(slides.length<=1)return;
    var current=0,auto=bar.dataset.autoRotate!=='false',speed=parseInt(bar.dataset.autoSpeed,10)||4000,timer=null;
    function go(idx,animate){if(animate===undefined)animate=true;current=((idx%slides.length)+slides.length)%slides.length;track.style.transition=animate?'transform 0.45s cubic-bezier(0.4,0,0.2,1)':'none';track.style.transform='translateX(-'+(current*100)+'%)';}
    function start(){timer=setInterval(function(){go(current+1);},speed);}
    function pause(){clearInterval(timer);}
    function restart(){pause();if(auto)start();}
    if(prev)prev.addEventListener('click',function(){go(current-1);restart();});
    if(next)next.addEventListener('click',function(){go(current+1);restart();});
    bar.addEventListener('mouseenter',pause);
    bar.addEventListener('mouseleave',restart);
    var touchStartX=0;
    bar.addEventListener('touchstart',function(e){touchStartX=e.touches[0].clientX;},{passive:true});
    bar.addEventListener('touchend',function(e){var diff=touchStartX-e.changedTouches[0].clientX;if(Math.abs(diff)>40){go(diff>0?current+1:current-1);restart();}});
    go(0,false);
    if(auto)start();
  }

  /* MEGA MENU */
  var MegaMenu={
    init:function(){
      var items=document.querySelectorAll('[data-mega-menu-item]');
      items.forEach(function(item){
        var trigger=item.querySelector('.mega-menu__nav-link'),dropdown=item.querySelector('.mega-menu__dropdown');
        if(!trigger||!dropdown)return;
        dropdown.removeAttribute('hidden');
        item.addEventListener('mouseenter',function(){trigger.setAttribute('aria-expanded','true');});
        item.addEventListener('mouseleave',function(){trigger.setAttribute('aria-expanded','false');});
        trigger.addEventListener('keydown',function(e){
          if(e.key==='Enter'||e.key===' '){e.preventDefault();var isOpen=trigger.getAttribute('aria-expanded')==='true';trigger.setAttribute('aria-expanded',String(!isOpen));dropdown.style.opacity=isOpen?'0':'1';dropdown.style.visibility=isOpen?'hidden':'visible';}
          if(e.key==='Escape'){trigger.setAttribute('aria-expanded','false');dropdown.style.opacity='0';dropdown.style.visibility='hidden';}
        });
      });
    }
  };

  /* STICKY HEADER */
  var StickyHeader={
    init:function(){
      var header=document.getElementById('ae-header');
      if(!header)return;
      window.addEventListener('scroll',function(){header.classList.toggle('ae-header--scrolled',window.scrollY>10);},{passive:true});
    }
  };

  /* MOBILE DRAWER */
  var MobileDrawer={
    drawer:null,overlay:null,burger:null,closeBtn:null,
    panelStack:[],activeBrand:'ae',

    init:function(){
      this.drawer=document.getElementById('ae-mobile-drawer');
      this.overlay=document.getElementById('mob-overlay');
      this.burger=document.getElementById('ae-burger');
      this.closeBtn=document.getElementById('mob-close-btn');
      if(!this.drawer)return;
      var self=this;

      if(this.burger)   this.burger.addEventListener('click',  function(){self.open();});
      if(this.closeBtn) this.closeBtn.addEventListener('click',function(){self.close();});
      if(this.overlay)  this.overlay.addEventListener('click', function(){self.close();});
      document.addEventListener('keydown',function(e){if(e.key==='Escape')self.close();});

      /* Brand tabs */
      this.drawer.querySelectorAll('[data-brand-tab]').forEach(function(tab){
        tab.addEventListener('click',function(){self.switchBrand(tab.dataset.brandTab);});
      });

      /* Sub-panel push */
      this.drawer.querySelectorAll('[data-panel]').forEach(function(btn){
        btn.addEventListener('click',function(){self.pushPanel(btn.dataset.panel);});
      });

      /* Sub-panel back */
      this.drawer.querySelectorAll('[data-back]').forEach(function(btn){
        btn.addEventListener('click',function(){self.popPanel();});
      });

      /* Accordion toggles inside sub-panels */
      this.drawer.querySelectorAll('.mob-accordion__trigger').forEach(function(trigger){
        trigger.addEventListener('click',function(){
          self.toggleAccordion(trigger.closest('.mob-accordion__item'));
        });
      });
    },

    toggleAccordion:function(item){
      if(!item)return;
      var isOpen=item.classList.contains('is-open');
      /* Close all siblings */
      var siblings=item.parentElement.querySelectorAll('.mob-accordion__item');
      siblings.forEach(function(s){ s.classList.remove('is-open'); });
      /* Toggle clicked */
      if(!isOpen) item.classList.add('is-open');
    },

    open:function(){
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden','false');
      this.overlay.classList.add('is-visible');
      if(this.closeBtn) this.closeBtn.classList.add('is-visible');
      document.body.classList.add('mob-drawer-open');
      if(this.burger)this.burger.setAttribute('aria-expanded','true');
      this.panelStack=[];
      this.activeBrand='ae';
      this.showBrandRoot('ae');
      var firstFocusable=this.drawer.querySelector('button,a[href]');
      if(firstFocusable)firstFocusable.focus();
    },

    close:function(){
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden','true');
      this.overlay.classList.remove('is-visible');
      if(this.closeBtn) this.closeBtn.classList.remove('is-visible');
      document.body.classList.remove('mob-drawer-open');
      if(this.burger){this.burger.setAttribute('aria-expanded','false');this.burger.focus();}
      var self=this;
      setTimeout(function(){self.panelStack=[];self.showBrandRoot(self.activeBrand);},320);
    },

    switchBrand:function(brand){
      this.activeBrand=brand;
      this.panelStack=[];
      this.drawer.querySelectorAll('[data-brand-tab]').forEach(function(tab){
        tab.classList.toggle('is-active',tab.dataset.brandTab===brand);
      });
      this.showBrandRoot(brand);
    },

    showBrandRoot:function(brand){
      var self=this;
      this.drawer.querySelectorAll('.mob-panel').forEach(function(p){p.classList.remove('is-active');});
      var root=document.getElementById('mob-panel-'+brand);
      if(root)root.classList.add('is-active');
      this.drawer.querySelectorAll('[data-brand-tab]').forEach(function(tab){
        tab.classList.toggle('is-active',tab.dataset.brandTab===self.activeBrand);
      });
    },

    pushPanel:function(panelId){
      var current=this.drawer.querySelector('.mob-panel.is-active');
      if(current)this.panelStack.push(current.id);
      if(current){current.style.transition='transform 0.28s cubic-bezier(0.4,0,0.2,1)';current.style.transform='translateX(-30%)';current.classList.remove('is-active');setTimeout(function(){current.style.transform='';},300);}
      var next=document.getElementById(panelId);
      if(next){next.classList.add('is-active');next.scrollTop=0;}
    },

    popPanel:function(){
      var prevId=this.panelStack.pop();
      if(!prevId)return;
      var current=this.drawer.querySelector('.mob-panel.is-active');
      if(current)current.classList.remove('is-active');
      var prev=document.getElementById(prevId);
      if(prev){prev.classList.add('is-active');prev.scrollTop=0;}
    }
  };

  /* Boot */
  document.addEventListener('DOMContentLoaded',function(){
    initAnnCarousel('announcement-bar','ann-track','ann-prev','ann-next');
    MegaMenu.init();
    StickyHeader.init();
    MobileDrawer.init();
  });

})();